import React, { useEffect } from 'react';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isDestructive?: boolean;
  isAlert?: boolean;
}

export default function ConfirmModal({
  isOpen,
  title,
  message,
  confirmText = '実行する',
  cancelText = 'キャンセル',
  onConfirm,
  onCancel,
  isDestructive = false,
  isAlert = false,
}: ConfirmModalProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!isOpen) return;
      if (e.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-backdrop"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(12px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
      onClick={onCancel}
    >
      <div
        className="glass-panel"
        style={{
          backgroundColor: 'var(--color-surface)',
          border: '1px solid rgba(231, 228, 223, 0.1)',
          borderRadius: '16px',
          padding: '32px',
          width: '450px',
          maxWidth: '90%',
          boxShadow: '0 12px 40px rgba(0, 0, 0, 0.5)',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          animation: 'modalScaleDown 0.3s cubic-bezier(0.25, 1, 0.5, 1)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          style={{
            margin: 0,
            fontSize: '20px',
            fontFamily: 'var(--font-heading-ja)',
            color: 'var(--color-accent)',
            borderBottom: '1px solid rgba(231, 228, 223, 0.08)',
            paddingBottom: '12px',
          }}
        >
          {title}
        </h3>

        <p
          style={{
            margin: 0,
            fontSize: '15px',
            lineHeight: '1.6',
            color: 'var(--color-text)',
            whiteSpace: 'pre-wrap',
            opacity: 0.9,
          }}
        >
          {message}
        </p>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '12px',
            marginTop: '8px',
          }}
        >
          {!isAlert && (
          <button
            type="button"
            onClick={onCancel}
            style={{
              padding: '10px 20px',
              borderRadius: '8px',
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              border: '1px solid rgba(231, 228, 223, 0.1)',
              color: 'var(--color-text)',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
            }}
          >
            {cancelText}
          </button>
          )}

          <button
            type="button"
            onClick={onConfirm}
            style={{
              padding: '10px 24px',
              borderRadius: '8px',
              backgroundColor: isDestructive ? 'var(--color-error)' : 'var(--color-primary)',
              border: 'none',
              color: '#fff',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = '0.9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = '1.0';
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
